<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Media Room'"></navbar>
			<!--导航-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/01顶部banner@2x.webp" class="bg" />
				<div class="msg_box">
					<div class="tit">Media Room</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="left" @click="goAbout">
					<div class="bg_box">
						<img src="../../assets/img/20230705-110247.webp" />
					</div>
					<div class="tit">
						<div>About CorDx</div>
						<img src="../../assets/img/组 32@2x.png" />
					</div>
					<div class="txt">
						CorDx is transforming the global diagnostics industry with innovative R&D solutions, a vertically integrated supply chain, and manufacturing footprints in the United States and around the world. Learn more here.
					</div>
				</div>
				<div class="right">
					<a href="https://cordx.com/uploads/cordx_logo-pack_rev20220525.zip" target="_blank">
						<div class="bg_box">
							<img src="../../assets/img/蒙版组-11@2x.webp" />
						</div>
						<div class="tit">
							<div style="color: #000000;">Official CorDx Imagery</div>
							<img src="../../assets/img/组 32@2x.png" />
						</div>
						<div class="txt">
							CorDx is built on accuracy, reliability, and innovation. We’re proud of our brand. Download official CorDx logos and imagery here (for non-commercial use only).
						</div>
					</a>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_2_main">
					<div class="title">Press Releases</div>
					<div class="block_2_box">
						<div
							v-for="(value, index) in newsData"
							:key="index"
							class="block_2_el"
							@mouseover="newsOver(value.id)"
							@mouseleave="newsLeave"
							@click="goResourcesInfo(value)"
						>
							<img :src="value.image" />
							<div class="msg_box">
								<div class="txt">{{ value.title }}</div>
							</div>
							<div class="time">{{ value.fabu_time }}</div>
							<div v-if="isShow == value.id" class="mask_box"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="mask_tit">{{ value.title }}</div>
								<div class="mask_txt">{{ value.description }}</div>
							</div>
						</div>
					</div>
					<div class="btn_box_more" style="position: absolute;left: 50%;transform: translate(-50%, 0px);" @click="goResources">
						View More<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_3_main">
					<div class="left">
						<div class="tit">Contact Us</div>
						<div class="txt">
							CorDx welcomes queries from professionals in the media and communications industry. Contact us via the form—we'll respond to you soon!
						</div>
						<img src="../../assets/img/蒙版组 1@2x (5).webp" />
					</div>
					<div class="right">
						<contact titleText="Submit"></contact>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import contact from '@/component/pc/contact.vue'  //联系我们
import { resourcesList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			newsData: [],  //新闻数据
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Media Room - CorDx';
		resourcesList({
			catid: 2,
			page: 1,
			page_size: 3,
			language: sessionStorage.getItem('lang'),
		}).then(res2 => {
			that.newsData = res2.data.data;
		});
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			// let { href } = that.$router.resolve({
			// 	path: '/resources-info',
			// 	query: {
			// 		id: value.unionid,
			// 	}
			// });
			// window.open(href, '_blank');
			let routeData = that.$router.resolve({name: "Resourcesinfo", params: { resourcesInfoId: value.custom } });
			window.open(routeData.href, '_blank');
		},
		//新闻滑入
		newsOver(value) {
			let that = this;
			that.isShow = value;
		},
		//新闻滑出
		newsLeave() {
			let that = this;
			that.isShow = null;
		},
		goAbout() {
			this.$router.push({ path: '/about' });
		},
		goResources() {
			this.$router.push({ path: '/resources' });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块3*/
	.block_3{
		width: 100%;
		padding: 120px 0 140px 0;
		background-color: transparent;
		background-image: linear-gradient(180deg,  #F1ECE6 20%, #FFFFFF 100%);
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			.left{
				flex: 1;
				padding-right: 50px;
				img{
					width: 100%;
				}
				.txt{
					padding: 20px 0 35px 0;
					font-size: 20px;
				}
				.tit{
					font-size: 45px;
				}
			}
			.right{
				flex: 2;
			}
		}
	}
	/*块2*/
	.block_2{
		width: 100%;
		background-color: transparent;
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 150px 0;
			.block_2_box{
				display: flex;
				padding: 60px 0 50px 0;
				.block_2_el{
					flex: 1;
					position: relative;
					margin: 0 20px;
					background-color: #ffffff;
					box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
					cursor: pointer;
					overflow: hidden;
					.mask_box{
						position: absolute;
						width: 100%;
						height: 100%;
						top: 0;
						background-color: #ffffff;
						padding: 34px;
						.mask_tit{
							font-size: 20px;
							color: #000000;
						}
						.mask_txt{
							padding-top: 40px;
							font-size: 16px;
							color: #706B69;
						}
					}
					.msg_box{
						width: 100%;
						padding: 30px 34px 120px 34px;
						border-top: 2px solid #0B318F;
						.txt{
							color: #000000;
							font-size: 22px;
						}
					}
					.time{
						position: absolute;
						z-index: 2;
						bottom: 40px;
						left: 34px;
						font-size: 18px;
						color: #706B69;
					}
					img{
						width: 100%;
						// height: auto;
						height: 227px;
						object-fit: cover;
					}
				}
			}
			.title{
				font-size: 45px;
				color: #000000;
			}
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		display: flex;
		margin: 0 auto;
		padding: 80px 0 0 0;
		.left:hover, .right:hover{
			.tit{
				img{
					transform: translateX(6px);
				}
			}
		}
		.left, .right{
			flex: 1;
			margin: 0 15px;
			cursor: pointer;
			.txt{
				font-size: 20px;
				color: #706B69;
			}
			.tit{
				padding: 20px 0 10px 0;
				position: relative;
				div{
					display: inline-block;
					font-size: 24px;
				}
				img{
					position: absolute;
					right: 0;
					width: 20px;
					padding-top: 2px;
					transition: all 0.3s;
				}
			}
			.bg_box{
				img{
					width: 100%;
				}
			}
		}
	}
	/*banner*/
	.banner_box{
		width: 100%;
		position: relative;
		.msg_box{
			position: absolute;
			top: 50%;
			left: 50%;
			width: 1140px;
			z-index: 1;
			transform: translate(-50%, -50%);
			color: #000000;
			text-align: center;
			.tit{
				font-size: 65px;
			}
		}
		.bg{
			width: 100%;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: transparent;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
